import { useQuery } from "@tanstack/react-query";
export const createJudgesQueries = (requests, queryClient) => ({
    useListJudges: (params, options = {}) => useQuery({
        queryKey: ["judges", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listJudges(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map